import { Component, OnInit, Input, Output, EventEmitter,ViewChild,ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../../products/services/product.service';
import { LabeledProductService } from '../../services/labeledproduct.service';
import { ShopService } from '../../../configuration/services/shop.service';
import { CategoryService } from '../../../common/services/category.service';
import { ProductCategoryService } from '../../../common/services/productcategory.service';
import {ProductStatusService} from '../../../configuration/services/product-status.service';
import {ProductOperatingSystemService} from '../../../configuration/services/product-operating-system.service';
import {ProductRamService} from '../../../configuration/services/product-ram.service';
import {ProductStorageCapacityService} from '../../../configuration/services/product-storage-capacity.service';
import {ProductTelephoneCompanyService} from '../../../configuration/services/product-telephone-company.service';
import {ProductCpuService} from '../../../configuration/services/product-cpu.service';
import {CarouselComponent} from "angular2-carousel";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as JsBarcode from 'jsbarcode';
import { Observable } from 'rxjs/Observable';

import { PurchaseProductService } from '../../../purchase/services/purchase-product.service';
import { RepurchaseProductService } from '../../../repurchase/services/repurchase-product.service';
import { ConsignmentProductService } from '../../../consignment/services/consignment-product.service';
import { ConsignmentProductStatusService } from '../../../consignment/services/consignment-product-status.service';
import { ConsignmentService } from '../../../consignment/services/consignment.service';
import { DistributorService } from '../../../distributors/services/distributor.service';
import { PersonService } from '../../../person/services/person.service';


import { ProductCategoryTempService } from '../../../common/services/productcategorytemp.service';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';

@Component({
    selector: 'app-view-labeledproduct',
    templateUrl: './view-labeledproduct.component.html',
    styleUrls: ['./view-labeledproduct.component.css'],
    providers: [DistributorService,LabeledProductService,ProductService,ShopService, CategoryService,ProductCategoryService,ProductStatusService,
        ProductOperatingSystemService,PersonService,ProductRamService,ProductStorageCapacityService,ProductTelephoneCompanyService,ProductCpuService,
        PurchaseProductService,RepurchaseProductService,ConsignmentProductService,ConsignmentService,ProductCategoryTempService,ConsignmentProductStatusService]
  })

export class ViewLabeledProductComponent implements OnInit {
    id: number = undefined;
    productId: number = undefined;
    private sub: any;
    labeledProduct: any = {
        subfamilies:[],
        available_online:true,
        availability_warning:false,
        distributor: null
    };

    type: number = undefined;
    shops:any = [];
    categories:any = [];
    families:any = [];
    subfamilies:any = [];  
    telephoneCompanies: any = [];
    operatingSystems: any = [];
    statuses: any = [];
    storageCapacities: any = [];
    rams: any = [];
    cpus: any =[];
    config: any = {'sourceField': ['name']};
    photos: any = [];
    photosForUpload: any = [];
    categorySelect:any = {};
    categoriesToAdd:any = [];
    product: any = {};
    purchase: any = {};
    repurchase: any = {};
    consignment: any = {};
    newProduct: boolean = false;
    distributors:any = [];
    distributor: any = {};
    distributorField: any;
    showDistributorsForm: boolean = false;
    showRecueLabeledProductTempleateForm: boolean = false;
    labeledProductsFilters:any = {
        brand:{contains: ""},
        model:{contains: ""},
        name: {contains: ""},
        short_description: {contains: ""},
        barcode:{contains: ""},
        manufacturer_barcode:{contains: ""}
    };
    labeledProducts: any = [];
    role:number = 3;
    userId:number= null;
    addToStock: boolean = false;
    person:any = {};
    templateRecovered: boolean = false;
  
    tempCategories:any = [];
    availableOnlineBeforeUpdate: boolean = true;
    clear: any = false;
    oldProductStock: number = 0;
    consignmentProductCurrentStatus: any = [];
    deliveryTimes:any = [
        "24/48h",
        "3/5d",
        "75d",
        "15/20d"
    ];
    labeledInProgress: boolean = false
    
    constructor(private route: ActivatedRoute, private router: Router, private productService:ProductService, private labeledProductService:LabeledProductService,
        private shopService:ShopService, private categoryService:CategoryService, private productCategoryService:ProductCategoryService, private productOperatingSystemService:ProductOperatingSystemService,
        private productRamService:ProductRamService,private productStatusService:ProductStatusService, private productStorageCapacityService:ProductStorageCapacityService, 
        private productTelephoneCompanyService:ProductTelephoneCompanyService,private productCpuService:ProductCpuService, private purchaseProductService:PurchaseProductService, private repurchaseProductService:RepurchaseProductService,
        private consignmentProductService:ConsignmentProductService,public toastr: ToastsManager,vcr: ViewContainerRef,
        private distributorService:DistributorService, private consignmentService: ConsignmentService,private personService: PersonService
        ,private productCategoryTempService:ProductCategoryTempService, private consignmentProductStatusService:ConsignmentProductStatusService) {this.toastr.setRootViewContainerRef(vcr); }
    
    @ViewChild('topCarousel') topCarousel: CarouselComponent;

    ngOnInit() {
        this.getProductOperatingSystems();
        this.getProductStatuses();
        this.getProductStorageCapacities();
        this.getProductTelephoneCompanies();
        this.getProductRams();
        this.getProductCpus();
        this.getDistributors();
        this.getShops().then(()=>{
            this.sub = this.route.params.subscribe(params => {
                this.route.queryParams.subscribe(queryParams => {
                    if (params['id'] !== undefined){
                        this.id = params['id'];
                        this.getLabeledProduct()
                        this.getProductPhotos();
                    }else if (queryParams['productId'] !== undefined){
                        this.productId = queryParams['productId'];
                        this.getProduct();
                    }else{
                        this.newProduct = true;
                        this.labeledProduct.available_online = false;
                        this.labeledProduct.availability_warning = true;
                    }
                });
                this.getCategories();
            });
        });
        try{
            this.role = JSON.parse(localStorage.getItem('user')).role;  
            this.userId = JSON.parse(localStorage.getItem('user')).id; 
          }catch(e){
          }
    }
    ngOnDestroy() {
      this.sub.unsubscribe();
    }
    prev(){
        this.topCarousel.slidePrev();
    }
    next(){
        this.topCarousel.slideNext();
    }

    distributorSelected(event){
        this.labeledProduct.distributor_id = event.id
    }

    getCategories(){
        var params = {
            where:{
                parent_id:0,       
            }
        }   
        this.categoryService.query(params)
        .subscribe((categories) => {
            this.categories = categories
            categories.sort(function(a, b){
                return a.name.localeCompare(b.name);
            });
            if (this.productId){
                this.productService.get(this.productId).subscribe((product) => {
                    if (product.type == 1){     
                        this.categorySelect.category=this.categories[15];
                    }
                    if (product.type == 2){     
                        this.categorySelect.category=this.categories[3];
                    } 
                    if (product.type == 4){     
                        this.categorySelect.category=this.categories[10]; 
                    }  
                    if (product.type != 3){
                        this.getFamilies();    
                    }        
                });
            }   
            if (this.tempCategories.length > 0){
                this.categorySelect.category = this.tempCategories[0]? this.categories.filter( (e) => {return e.id == this.tempCategories[0].id})[0] :null;
                if (this.categorySelect.category)
                    this.getFamilies();  
            }
        });   
    }
    getFamilies(){
        var params = {
            where:{
                parent_id:this.categorySelect.category.id
            } 
        }
        this.categoryService.query(params)
        .subscribe((families) => {
            this.families = families;
            families.sort(function(a, b){
                return a.name.localeCompare(b.name);
            });
            if (this.productId){
                this.productService.get(this.productId).subscribe((product) => {
                    if(product.type == 1 && product.sub_type == 1){     
                        this.categorySelect.family = this.families[0]; 
                    }     
                    if(product.type == 1 && product.sub_type == 2){     
                        this.categorySelect.family = this.families[1]; 
                    }
                    if(product.type == 2){     
                        this.categorySelect.family = this.families[1];
                    }
                    if(product.type == 4 && product.sub_type == 1 ){     
                        this.categorySelect.family = this.families[5]; 
                    }
                    if(product.type == 4 && product.sub_type == 2 ){     
                        this.categorySelect.family = this.families[5];
                    }  
                    if (product.type != 3){
                        this.getSubFamilies();
                    }
                }); 
            }
            if (this.tempCategories.length > 0){
                this.categorySelect.family = this.tempCategories[1]? this.families.filter( (e) => {return e.id == this.tempCategories[1].id})[0] :null;
                if (this.categorySelect.family)
                    this.getSubFamilies();  
            }
        });
    }

    getSubFamilies(){
        var params = {
            where:{
                parent_id:this.categorySelect.family.id
            }
        }
        this.categoryService.query(params)
        .subscribe((subfamilies) => {
            this.subfamilies = subfamilies;
            subfamilies.sort(function(a, b){
                return a.name.localeCompare(b.name);
            });
            if (this.tempCategories.length > 0){
                this.categorySelect.subfamily = this.tempCategories[2]? this.subfamilies.filter( (e) => {return e.id == this.tempCategories[2].id})[0] :null;
            }
        });
    }

    getProductCpus(){
        this.productCpuService.query({}).subscribe((productCpus) => {
          this.cpus = productCpus; 
        });
    }
    cpuSelected(e){
        this.labeledProduct.cpu = e.name
    }

    getProductOperatingSystems(){
        this.productOperatingSystemService.query({}).subscribe((productOperatingSystems) => {
            this.operatingSystems = productOperatingSystems; 
        });
    }
    operatingSystemSelected(e){
        this.labeledProduct.so = e.name
    }

    getProductStatuses(){
        this.productStatusService.query({}).subscribe((productStatuses) => {
            this.statuses = productStatuses; 
        });
    }
    productStatusesSelected(e){
        this.labeledProduct.status = e.name
    }


    getProductStorageCapacities(){
        this.productStorageCapacityService.query({}).subscribe((productStorageCapacities) => {
            this.storageCapacities = productStorageCapacities; 
        });
    }
    storageCapacitiesSelected(e){
        this.labeledProduct.storage_capacity = e.name
    }

    getProductTelephoneCompanies(){
        this.productTelephoneCompanyService.query({}).subscribe((productTelephoneCompanies) => {
            this.telephoneCompanies = productTelephoneCompanies; 
        });
    }
    telephoneCompanySelected(e){
        this.labeledProduct.telephone_company = e.name
    }
    getProductRams(){
        this.productRamService.query({}).subscribe((productRams) => {
            this.rams = productRams; 
        });
    }
    ramSelected(e){
        this.labeledProduct.ram = e.name
    }
    getShops(){
        return new Promise((resolve, reject) => {
            this.shopService.query({})
            .subscribe((shops) => {
                this.shops = shops;
                resolve();
            });
        });
    }

    getLabeledProductFromFields(){
        if (this.labeledProductsFilters.brand.contains != "" || this.labeledProductsFilters.model.contains != "" || this.labeledProductsFilters.name.contains != "" || this.labeledProductsFilters.short_description.contains != "" || this.labeledProductsFilters.barcode.contains != "" || this.labeledProductsFilters.manufacturer_barcode.contains != ""){
            var params = {
                where: _.cloneDeep(this.labeledProductsFilters),
                limit: 100
            };

            this.labeledProductService.query(params).subscribe((labeledProducts) => {
                this.labeledProducts = labeledProducts;
            });
        }else{
            this.labeledProducts = [];
        }
    }

    selectLabeledProductToAddStock(labeledProduct){
        var newStock = this.labeledProduct.stock + labeledProduct.stock;
        this.labeledProduct = labeledProduct;
        this.labeledProduct.stock = newStock;
        this.labeledProduct.shop_id = this.labeledProduct.shop.id;
        this.labeledProductService.getProductPhotos(labeledProduct.id)
        .subscribe((result) => {
            this.photos = result;
        });        
        this.showRecueLabeledProductTempleateForm = !this.showRecueLabeledProductTempleateForm;
        this.getSubfamilyToAddCategory(labeledProduct);
    }

    selectLabeledProduct(labeledProduct){
        this.templateRecovered = true;
        this.labeledProduct.name = labeledProduct.name;
        this.labeledProduct.short_description = labeledProduct.short_description;
        this.labeledProduct.description = labeledProduct.description;
        this.labeledProduct.shipping_cost_tenerife = labeledProduct.shipping_cost_tenerife;
        this.labeledProduct.shipping_cost_canary_island = labeledProduct.shipping_cost_canary_island;
        this.labeledProduct.available_online = labeledProduct.available_online;
        this.labeledProduct.min_stock = labeledProduct.min_stock;
        this.labeledProduct.min_stock_quantity = labeledProduct.min_stock_quantity;
        this.labeledProductService.getProductPhotos(labeledProduct.id)
        .subscribe((result) => {
            this.photosForUpload = [];
            result.forEach((p)=>{
                var photo = {
                    file: {
                        name: p.filename
                    },
                    src: p.image
                }
                this.photosForUpload.push(photo);
            });
        })
        this.showRecueLabeledProductTempleateForm = !this.showRecueLabeledProductTempleateForm;
        this.getSubfamilyToAddCategory(labeledProduct);
    }

    getLabeledProduct(){
        this.labeledProductService.get(this.id).subscribe((labeledProduct) => {
            this.labeledProduct = labeledProduct;
            this.type = labeledProduct.type;
            this.person = labeledProduct.person;
            this.labeledProduct.shop_id = this.labeledProduct.shop.id;
            this.labeledProduct.distributor_id = labeledProduct.distributor?labeledProduct.distributor.id:'';
            this.labeledProduct.d = labeledProduct.distributor?labeledProduct.distributor.name:'';
            this.labeledProduct.naturalCreatedAt = moment(this.labeledProduct.createdAt).format("DD-MM-YYYY HH:mm");
            this.oldProductStock = labeledProduct.stock;
            this.getSubfamily(this.labeledProduct);
            this.getProductCategoryTemp(this.labeledProduct);
            this.labeledProduct.oldStock = labeledProduct.stock;
            this.getProductFromLabeledProductandIncomingEntity(labeledProduct);

            this.availableOnlineBeforeUpdate = this.labeledProduct.available_online;
            this.getProductCategoryTemp(this.labeledProduct).then(()=>{
                this.getCategories();
            })
            if (this.labeledProduct.barcode){
                setTimeout( ()=>{
                    console.log(this.labeledProduct.barcode)
                    JsBarcode("#barcode",this.labeledProduct.barcode,{format: "CODE128",width:7,fontSize: 50,textMargin:-12,margin:0, height: 70});
                    this.labeledProduct.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
                },0);
            } 
       });
    }

    getProductFromLabeledProductandIncomingEntity(labeledProduct){
        var params = {
            where:{
                labeledproduct_id:labeledProduct.id 
            }
        }
        this.productService.query(params).subscribe((products) => {  
            if(products[0]){
                this.getProductIncomingentity(products[0]);
            }
        });
    }

    getConsignmentProductStatusFromConsignmentProduct(id){
        var params = {
            where: {
                consignmentproduct:id, 
                status:6,
                quantity:{
                    ">":0
                }
            }
        };
        this.consignmentProductStatusService.query(params).subscribe((statuses)=>{
            if (statuses.length == 0){
                this.toastr.error('', 'Este producto se ha cambiado de estado y no tiene estado pendiente de etiquetar, ¿seguro que quiere continuar?', {dismiss: "controlled",showCloseButton:true});
            }else{
                this.consignmentProductCurrentStatus = statuses[0];
            }
        });
    }

    getPersonFromConsignment(id){
        this.consignmentService.get(id).subscribe((consignment) => {
            this.person = consignment.person;
            this.labeledProduct.person_id = consignment.person && consignment? consignment.person.id:null;
        });
    }

    getProduct(){
        this.productService.get(this.productId).subscribe((product) => {
            this.product = product;
            if (product.labeledproduct_id){
                this.router.navigate(["/labeledproduct/view/"+product.labeledproduct_id])     
            }else{
                this.type = product.type;
                if (this.product.consignmentProduct.length > 0){
                    this.getPersonFromConsignment(this.product.consignmentProduct[0].consignment);
                    this.getConsignmentProductStatusFromConsignmentProduct(this.product.consignmentProduct[0].id);
                }

                switch(product.type) {
                    case 1:
                        this.parseMobileTablets(product);
                        this.getProductIncomingentity(this.product);
                        break;
                    case 2:
                        this.parseConsoles(product);
                        this.getProductIncomingentity(this.product);
                        break;
                    case 3:
                        this.parseArticles(product);
                        this.getProductIncomingentity(this.product);
                        break;
                    case 4:
                        this.parseComputersLaptops(product);
                        this.getProductIncomingentity(this.product);
                        break;
                    default:
                }
                switch(product.status) {
                    case "Nuevo":
                        this.labeledProduct.description = "No se ha usado nunca, es un artículo a estrenar, conservando todos los precintos, embalajes y accesorios originales.";
                        break;
                    case "Seminuevo":
                        this.labeledProduct.description = "En el artículo se puede apreciar algún síntoma de uso. Pudiendo presentar leves marcas físicas. Su funcionamiento es perfecto.";
                        break;
                    case "Como Nuevo":
                        this.labeledProduct.description = "No se aprecian signos visibles de uso, estando en perfecto estado.";
                        break;
                    case "Usado":
                        this.labeledProduct.description = "El artículo se encuentra con síntomas de uso. Pudiendo presentar algunas marcas físicas. Su funcionamiento es el correcto para lo que ha sido destinado.";
                        break;
                    default:
                }
            }
        });
    }

    parseMobileTablets(product) {
        let subTypes =["Móvil","Tablet"]
        this.labeledProduct.type = product.type;
        this.labeledProduct.imei1 = product.imei;
        this.labeledProduct.imei2 = product.imei2;
        this.labeledProduct.serial_number = product.serial_number;
        this.labeledProduct.storage_capacity = product.storage_capacity;
        this.labeledProduct.telephone_company = product.telephone_company;
        this.labeledProduct.status = product.status;
        this.labeledProduct.sale_price = product.sale_price;
        this.labeledProduct.purchase_price = product.purchase_price;
        this.labeledProduct.cost_price = product.cost_price;
        this.labeledProduct.name = (product.sub_type?subTypes[product.sub_type-1]:" ")+ " " + product.brand + " " + product.model;
        this.labeledProduct.stock = 1;
    }

    parseConsoles(product) {
        this.labeledProduct.type = product.type;
        this.labeledProduct.serial_number = product.serial_number;
        this.labeledProduct.storage_capacity = product.storage_capacity;
        this.labeledProduct.status = product.status;
        this.labeledProduct.sale_price = product.sale_price;
        this.labeledProduct.purchase_price = product.purchase_price;
        this.labeledProduct.cost_price = product.cost_price;
        this.labeledProduct.name = "Consola "+ product.brand + " " + product.model;
        this.labeledProduct.stock = 1;
       
        
    }

    parseArticles(product) {
        this.labeledProduct.type = product.type;
        this.labeledProduct.serial_number = product.serial_number;
        this.labeledProduct.status = product.status;
        this.labeledProduct.sale_price = product.sale_price;
        this.labeledProduct.purchase_price = product.purchase_price;
        this.labeledProduct.cost_price = product.cost_price;
        this.labeledProduct.name = product.description;
        this.labeledProduct.stock = product.stock;
    }

    parseComputersLaptops(product) {
        let subTypes =["PC","Portatil"]
        this.labeledProduct.type = product.type;
        this.labeledProduct.serial_number = product.serial_number;
        this.labeledProduct.storage_capacity = product.storage_capacity;
        this.labeledProduct.ram = product.ram;
        this.labeledProduct.so = product.so;
        this.labeledProduct.cpu = product.cpu;
        this.labeledProduct.status = product.status;
        this.labeledProduct.sale_price = product.sale_price;
        this.labeledProduct.purchase_price = product.purchase_price;
        this.labeledProduct.cost_price = product.cost_price;
        this.labeledProduct.name = (product.sub_type?subTypes[product.sub_type-1]:" ") + " " + product.brand + " " + product.model;
        this.labeledProduct.stock = 1;
    }

    getProductIncomingentity(product){
        var params = {
            where: {product_id:product.id}
        };
        this.purchaseProductService.query(params).subscribe((purchaseProducts) =>{
            if (purchaseProducts.length > 0){
                this.purchase = purchaseProducts[0].purchase;    
            }
        });
        this.repurchaseProductService.query(params).subscribe((repurchaseProducts) =>{
            if (repurchaseProducts.length > 0){
                this.repurchase = repurchaseProducts[0].repurchase;    
            }
        });
        this.consignmentProductService.query(params).subscribe((consignmentProducts) =>{
            if (consignmentProducts.length > 0){
                this.consignment = consignmentProducts[0].consignment;
            }   
        });
    }
    

    addProductCategory(){
        let subfamilyToAdd = {
            naturalCategory: this.categorySelect.category.name,
            naturalFamily: this.categorySelect.family.name,
            naturalSubfamily: this.categorySelect.subfamily.name,
            subfamily_id : this.categorySelect.subfamily.id
        }
        this.categoriesToAdd.push(subfamilyToAdd);
        this.categorySelect=[];  
    }

    deleteProductCategory(category){
        if (category.id){
            this.productCategoryService.delete(category.id).subscribe(() =>{
                this.getSubfamily(this.labeledProduct);
            });
        }else{
            let index = _.findIndex(this.categoriesToAdd, (e)=>{return e.naturalCategory == category.naturalCategory && e.naturalFamily == category.naturalFamily && e.naturalSubfamily == category.naturalSubfamily});
            this.categoriesToAdd.splice(index,1);
        }
    }

    labelProduct(printTag){
        this.labeledInProgress = true;
        if (this.photosForUpload.length < 1 && this.photos.length < 1){
            this.labeledProduct.available_online = false;
        }
        let params = {
            sort: 'id DESC',
            skip: 0,
            limit: 1
        }
        this.labeledProductService.query(params).subscribe((lastLabeledProduct) =>{
            if (lastLabeledProduct[0].barcode != null){
                this.labeledProduct.barcode = parseInt(lastLabeledProduct[0].barcode) + 1;
            }
            if(this.checkMandatoryFields(this.labeledProduct) === true){
                this.labeledProductService.create(this.returnProperties(this.labeledProduct)).subscribe((labeledProduct) =>{
                    this.availableOnlineBeforeUpdate = labeledProduct.available_online;
                    this.id = labeledProduct.id;
                    this.labeledProduct.id = labeledProduct.id;
                    if (this.productId){
                        this.productService.update({id:this.productId, labeledproduct_id: labeledProduct.id})
                        .subscribe(() => {
                        });
                    }
                    let observableCategoriesAddRequest = [];
                    this.categoriesToAdd.forEach((cateogryToAdd)=>{
                        observableCategoriesAddRequest.push(this.productCategoryService.create({labeledproduct:labeledProduct.id, category_id:cateogryToAdd.subfamily_id}));
                    });
                    Observable.forkJoin(observableCategoriesAddRequest)
                        .subscribe(data => {
                        this.getLabeledProduct();
                        this.labeledInProgress = false;
                        this.categoriesToAdd = [];
                    });
                    this.uploadPhotos();
                    this.updateConsignmentProductStatus();
                    if (printTag){
                        JsBarcode("#barcode",labeledProduct.barcode,{format: "CODE128",width:7,fontSize: 50,textMargin:-12,margin:0, height: 70});
                        this.labeledProduct.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
                        setTimeout( ()=>{
                            this.printTags();
                            if (this.newProduct){
                                this.router.navigate(["/labeledproduct"]); 
                            }else{
                                this.router.navigate(["/product/listtolabel"]); 
                            }
                        },500);
                    }else{
                        if (this.newProduct){
                            this.router.navigate(["/labeledproduct"]); 
                        }else{
                            this.router.navigate(["/product/listtolabel"]); 
                        }
                    }
                });
            } 
        });     
    }

    updateConsignmentProductStatus(){
        if (this.consignmentProductCurrentStatus && this.consignmentProductCurrentStatus.id){
            let consignmentProductStatusBody = {
                consignment_product_id: this.consignmentProductCurrentStatus.consignmentproduct.id,
                product_consignment_status_id: 1,
                quantity: this.consignmentProductCurrentStatus.quantity
            }
            this.consignmentProductStatusService.create(consignmentProductStatusBody)
              .subscribe(() => {
                let body = {
                    id: this.consignmentProductCurrentStatus.id, 
                    quantity: 0
                }
                this.consignmentProductStatusService.update(body)
                .subscribe(() => {
                });
            });
        }
    }
   
    checkMandatoryFields(labeledProduct){
        if(labeledProduct.status!==null && labeledProduct.stock!==null && (labeledProduct.sale_price!==null && labeledProduct.sale_price!=="") && labeledProduct.shop_id!== null 
            && (!this.newProduct || labeledProduct.distributor_id)){  
            if ((this.labeledProduct && this.labeledProduct.subfamilies && this.labeledProduct.subfamilies.length > 0) || this.categoriesToAdd.length > 0){
                return true;
            }else{
                this.toastr.error('', 'Debes añadir al menos una categoria', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                return false;
            }
        }
        else{
            this.toastr.error('', 'Faltan campos obligatorios', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
            return false;
        }
    }
       
    updateLabeledProduct(){
        if (this.oldProductStock <= this.labeledProduct.stock || this.role == 1){
            if (this.photosForUpload.length < 1 && this.photos.length < 1){
                this.labeledProduct.available_online = false;
            }
            if (this.availableOnlineBeforeUpdate || !this.labeledProduct.available_online){
                if(this.checkMandatoryFields(this.labeledProduct) === true){
                    this.labeledProductService.update(this.returnProperties(this.labeledProduct)).subscribe((labeledProduct) =>{
                        this.availableOnlineBeforeUpdate = labeledProduct.available_online;
                        let observableCategoriesAddRequest = [];
                        this.categoriesToAdd.forEach((cateogryToAdd)=>{
                            observableCategoriesAddRequest.push(this.productCategoryService.create({labeledproduct:labeledProduct.id, category_id:cateogryToAdd.subfamily_id}));
                        });
                        Observable.forkJoin(observableCategoriesAddRequest)
                            .subscribe(data => {
                            this.getLabeledProduct();
                            this.categoriesToAdd = [];
                        });
                        this.toastr.success('', 'Producto etiquetado actualizado', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                    });
                }
            }else{//This is only when the product was created and the image or category was added before and we want to set it in the website now.
                if(this.checkMandatoryFields(this.labeledProduct) === true){
                    this.labeledProductService.update(this.returnProperties(this.labeledProduct)).subscribe((labeledProduct) =>{
                        this.availableOnlineBeforeUpdate = labeledProduct.available_online;
                        let observableCategoriesAddRequestToDelete = [];
                        this.labeledProduct.subfamilies.forEach((s) =>{
                            let subfamilyToAdd = {
                                subfamily_id : s.category.id
                            }
                            this.categoriesToAdd.push(subfamilyToAdd);
                            observableCategoriesAddRequestToDelete.push(this.productCategoryService.delete(s.id));
                        });
                        let observableCategoriesAddRequest = [];
                        this.categoriesToAdd.forEach((cateogryToAdd)=>{
                            observableCategoriesAddRequest.push(this.productCategoryService.create({labeledproduct:labeledProduct.id, category_id:cateogryToAdd.subfamily_id}));
                        });
                        if (observableCategoriesAddRequestToDelete && observableCategoriesAddRequestToDelete.length > 0){
                            Observable.forkJoin(observableCategoriesAddRequestToDelete).subscribe(data => {
                                Observable.forkJoin(observableCategoriesAddRequest)
                                    .subscribe(data => {
                                    this.getLabeledProduct();
                                    this.categoriesToAdd = [];
                                });
                            });
                        }else{
                            Observable.forkJoin(observableCategoriesAddRequest)
                            .subscribe(data => {
                                this.getLabeledProduct();
                                this.categoriesToAdd = [];
                            });
                        }
                        this.labeledProductService.triggerProductPhotosInP(this.labeledProduct.id).subscribe((labeledProduct) =>{});
                        this.toastr.success('', 'Producto etiquetado actualizado', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                    });
                }
            }
        }else{
            this.toastr.error('', 'No puedes poner un stock inferior al actual', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
        }
    }

    labelProductToAddStock(){
        this.labeledProductService.update({id: this.labeledProduct.id, stock: this.labeledProduct.stock}).subscribe((labeledProduct) =>{
            if (this.productId){
                this.productService.update({id:this.productId, labeledproduct_id: this.labeledProduct.id})
                .subscribe(() => {
                });
            }
            this.printTags();
            this.router.navigate(["/labeledproduct/view/"+labeledProduct.id]) 
        });
    }

    getSubfamily(labeledProduct){
        var params = {
            where:{
                labeledproduct_id:labeledProduct.id
            }
        }
        this.productCategoryService.query(params).subscribe((subfamilies) =>{
            this.labeledProduct.subfamilies = [];
            if (subfamilies && subfamilies[0]){
                this.labeledProduct.subfamilies = subfamilies;
                this.labeledProduct.subfamilies.forEach((subfamily) =>{
                    this.getCategoryTree(subfamily)
                });
            }
        });
    }

    getSubfamilyToAddCategory(labeledProduct){
        var params = {
            where:{
                labeledproduct_id:labeledProduct.id
            }
        }
        this.productCategoryService.query(params).subscribe((subfamilies) =>{
            if (subfamilies && subfamilies[0]){
                subfamilies.forEach((s)=>{
                    this.categoriesToAdd.push({
                        subfamily_id : s.category.id,
                        category: s.category
                    });
                });
                this.categoriesToAdd.forEach((subfamily) =>{
                    this.getCategoryTree(subfamily);
                });
            }
        });
    }

    search(nif){
        let params={
          nif: nif
        }
        this.personService.query(params)
        .subscribe((people) => {
            var person = people[0];
            if (person){
                this.person = person;
                this.labeledProduct.person_id = person.id;
            }
        });
    }

    getCategoryTree(subfamily){
        subfamily.naturalSubfamily = subfamily.category.name;
        var params = {
            where:{
                id:subfamily.category.parent_id
            }
        }
        this.categoryService.query(params)
        .subscribe((family) => {
            subfamily.naturalFamily = family[0].name;
            var params2 = {
                where:{
                    id:family[0].parent_id
                }
            }
            this.categoryService.query(params2)
            .subscribe((category) => {
                subfamily.naturalCategory = category[0]? category[0].name: "";
            });
        });
    }


    returnProperties(labeledProduct){
        var properties = {
            type: labeledProduct.type,
            name: labeledProduct.name,  
            short_description: labeledProduct.short_description,       
            imei1: labeledProduct.imei1,
            imei2: labeledProduct.imei2,
            serial_number: labeledProduct.serial_number,
            storage_capacity: labeledProduct.storage_capacity,
            telephone_company: labeledProduct.telephone_company,
            status: labeledProduct.status,
            description: labeledProduct.description,
            cpu: labeledProduct.cpu,
            ram: labeledProduct.ram,
            so: labeledProduct.so,
            stock: labeledProduct.stock,
            purchase_price: labeledProduct.purchase_price,
            sale_price: labeledProduct.sale_price,
            shipping_cost_tenerife: labeledProduct.shipping_cost_tenerife !== ""?labeledProduct.shipping_cost_tenerife:null,
            shipping_cost_canary_island: labeledProduct.shipping_cost_canary_island !== ""?labeledProduct.shipping_cost_canary_island:null,
            shipping_cost_mainland: labeledProduct.shipping_cost_mainland !== ""?labeledProduct.shipping_cost_mainland:null,
            available_online: labeledProduct.available_online,
            availability_warning: labeledProduct.availability_warning,
            min_stock: labeledProduct.min_stock,
            min_stock_quantity: labeledProduct.min_stock_quantity,
            manufacturer_barcode: labeledProduct.manufacturer_barcode,
            shop_id: labeledProduct.shop_id,
            barcode: labeledProduct.barcode,
            person_id: labeledProduct.person_id,
            distributor_id: labeledProduct.distributor_id,
            available_online_without_stock: labeledProduct.available_online_without_stock,
            delivery_time: labeledProduct.delivery_time
        }
        if (labeledProduct.id){
          properties['id'] = labeledProduct.id;
        }
        return properties;
    }

    onUploadFinished(file){
        this.photosForUpload.push(file);
    }

    onRemoved(file){
        let index = _.findIndex(this.photosForUpload,(e)=> e.file.name === file.file.name);
        if (index !== -1){
            this.photosForUpload.splice(index,1);
        }
    }

    uploadPhotos(){
        let photos = _.cloneDeep(this.photosForUpload);
        this.photosForUpload = [];
        photos.forEach((file, index)=>{
            setTimeout(()=>{
                this.saveAddPhoto(file);
            },(2000*index));
        });
        this.clear =document.getElementsByClassName("img-ul-clear");
        if (this.clear[0]){
            this.clear[0].click();
        }
    }

    saveAddPhoto(photo){
        var image = {
            id: this.labeledProduct.id,
            photo: photo.src,
            filename: photo.file.name
        }
        this.labeledProductService.saveProductPhotos(image)
        .subscribe((result) => {
            this.getProductPhotos();
        })
    }

    deleteProductPhoto(filename){
        this.labeledProductService.deleteProductPhoto(this.id, filename)
        .subscribe((result) => {
            this.getProductPhotos();
        })
    }

    getProductPhotos(){
        this.labeledProductService.getProductPhotos(this.id)
        .subscribe((result) => {
            this.photos = result;
        })
    }
    getDistributors(){
        this.distributorService.query({}).subscribe((distributors) => {
          this.distributors = distributors; 
        });
    }

    saveDistributor(){
        this.distributorService.create(this.distributor)
        .subscribe((distributor) => {
            this.getDistributors();
            this.distributor = {};
            this.showDistributorsForm = false;
        });
    }

    markAsLabeled(){
        if (this.productId){
            this.productService.update({id:this.productId, labeledproduct_id: -1})
            .subscribe(() => {
                this.router.navigate(["/product/listtolabel"]) 
            });
        }
    }

    printTags(){
        document.getElementById("ticket").classList.remove('hide')
        window.print();
        document.getElementById("ticket").classList.add('hide')
    }

    getProductCategoryTemp(labeledProduct){
        return new Promise((resolve, reject) => {
            let tempCategories = [];
            var params = {
                where:{
                    labeledproduct_id:labeledProduct.id
                }
            }
            this.productCategoryTempService.query(params).subscribe((subfamilies) =>{
                let subfamily = subfamilies[0];
                if (subfamily && subfamily.category.id){
                    tempCategories.unshift(subfamily.category);
                    this.tempCategories = tempCategories;
                }
                if (subfamily && subfamily.category.parent_id != 0){
                    var params = {
                        where:{
                            id:subfamily.category.parent_id
                        }
                    }
                    this.categoryService.query(params)
                    .subscribe((family) => {
                        tempCategories.unshift(family[0])
                        this.tempCategories = tempCategories;
                        if (family[0].parent_id != 0){
                            var params2 = {
                                where:{
                                    id:family[0].parent_id
                                }
                            }
                            this.categoryService.query(params2)
                            .subscribe((category) => {
                                tempCategories.unshift(category[0]);
                                this.tempCategories = tempCategories;
                                resolve();
                            });
                        }else{
                            resolve();
                        }
                    });
                }else{
                    resolve();
                }
            });
        });
    }

    calculatePurchasePrice(){
        if (this.consignment != null && this.consignment.id != null){
          if (this.labeledProduct.sale_price <= 2 ){
            this.labeledProduct.purchase_price = Math.round((this.labeledProduct.sale_price*0.5)*100)/100;
          }else{
            this.labeledProduct.purchase_price = Math.round((this.labeledProduct.sale_price*0.6)*100)/100;
          }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/labeledproducts/components/view-labeledproduct/view-labeledproduct.component.ts